module.exports = __webpack_public_path__ + "img/dealer.b46fd2de.svg";